import "./contact.scss";
import Instagram from "../../img/Instagram_color.png";
import LinkedIn from "../../img/LinkedIn_color.png";
import GitHub from "../../img/GitHub.png";
import Gmail from "../../img/Gmail.png";
import Twitter from "../../img/Twitter.png";

function contact() {
  return (
    <section className="main-container" id="contact">
      <hr />
      <div className="container">
        <h2 className="heading">
          <span className="heading-main">Contact Me</span>
          <span className="heading-sub">
            Feel free to reach out to me through my social media channels, and
            I'll respond promptly to any messages or inquiries.
          </span>
        </h2>
        <div className="contact-container">
          <div className="contact-button">
            <a
              href="https://www.instagram.com/soham___2003/"
              target="_SM"
              className="btn"
              to="projects"
              smooth={true}
            >
              <img src={Instagram}></img>
            </a>
          </div>
          <div className="contact-button">
            <a
              href="https://www.linkedin.com/in/soham-mandaliya/"
              target="_SM"
              className="btn"
              to="projects"
              smooth={true}
            >
              <img src={LinkedIn}></img>
            </a>
          </div>
          <div className="contact-button">
            <a
              href="https://github.com/SohamM2003"
              target="_SM"
              className="btn"
              to="projects"
              smooth={true}
            >
              <img src={GitHub}></img>
            </a>
          </div>
          <div className="contact-button">
            <a href="mailto:sohammandaliya@gmail.com" target="_SM" className="btn" to="projects" smooth={true}>
              <img src={Gmail}></img>
            </a>
          </div>
          <div className="contact-button">
            <a
              href="https://twitter.com/soham___2003"
              target="_SM"
              className="btn"
              to="projects"
              smooth={true}
            >
              <img src={Twitter}></img>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default contact;
